import { Box, BoxProps, Heading, Text } from '@wix/design-system';
import {
  STUDIO_HIGHLIGHT_BG_COLOR,
  useIsStudioNewUi,
} from '@wix/package-picker-shared-studio';
import { Check } from '@wix/wix-ui-icons-common/lazy';
import { ConfirmSmall } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import s from './BannerLayout.scss';

interface BannerLayoutProps extends BoxProps {
  title: string;
  items: (string | React.ReactNode)[];
  backgroundColor?: string;
}

export const BannerLayout = ({
  title,
  items,
  backgroundColor = '#06063a',
}: BannerLayoutProps) => {
  const isStudioNewUi = useIsStudioNewUi();

  if (isStudioNewUi) {
    return (
      <Box
        direction="horizontal"
        width="100%"
        padding="68px 20px SP8 SP8"
        boxSizing="border-box"
        align="space-between"
        gap="SP4"
        borderRadius="24px"
        backgroundColor={STUDIO_HIGHLIGHT_BG_COLOR}
      >
        <Box maxWidth="257px">
          <Heading size="extraLarge" className={s.bannerTitle}>
            {title}
          </Heading>
        </Box>
        <Box display="block" width="806px" columnCount={2} columnGap="46px">
          {items.map((item, idx) => (
            <Box
              key={idx}
              marginBottom="20px"
              verticalAlign="middle"
              gap="8px"
            >
              <ConfirmSmall />
              <Text size="small">{item}</Text>
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      direction="horizontal"
      width="100%"
      padding="126px 48px 96px"
      boxSizing="border-box"
      gap="100px"
      backgroundColor={backgroundColor}
    >
      <Box maxWidth="254px" minWidth="236px">
        <Heading light size="extraLarge">
          {title}
        </Heading>
      </Box>
      <Box gap="24px">
        <Box display="block" minWidth="648px" maxWidth="760px" columnCount={2}>
          {items.map((item, idx) => (
            <Box
              marginBottom="30px"
              verticalAlign="middle"
              maxWidth="max-content"
              gap="SP1"
              key={idx}
            >
              <Check color="white" />
              <Text light weight="bold">
                {item}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
